import React from 'react';
import { Button, LoadingSpinner } from 'pepsico-ds';

const OnboardingActionCard = ({
  dotColor = 'bg-red-500',
  showDot = true,
  title = 'Title',
  subtext = 'Subtext',
  storeCount = null,
  onTakeAction = () => {},
  isLoading = false,
}) => {
  return (
    <div className="flex items-center justify-between p-4 bg-[#1d1d1d] rounded-lg mt-4 mb-4 border border-[#4E4E4E] h-[104px] drop-shadow-[0_4px_12px_rgba(0,0,0,0.5)]">
      <div className="flex flex-col items-start">
        <div className="flex flex-row justify-start items-center mb-2">
          {showDot && (
            <span
              className={`w-3 h-3 rounded-full mr-2 ${dotColor} `}
            />
          )}
          <h6 className="font-semibold text-white text-[18px]">{title}</h6>
          {isLoading ? (
            <div className="ml-2 mt-1">
              <LoadingSpinner size={{ height: '20px', width: '20px' }} />
            </div>
          ) : (
            storeCount !== null && (
              <p className="text-[#66A5E7] text-[14px] ml-2 mt-1">
                {storeCount.toLocaleString()} {storeCount === 1 ? 'Store' : 'Stores'}
              </p>
            )
          )}
        </div>
        <div className="flex flex-col justify-start">
            <p className="text-[14px] text-white">{subtext}</p>
        </div>
      </div>
      <div className="flex items-center action-card-button-container">
        <Button onClick={onTakeAction } isDark={true} variant="primary" size="medium" iconTrailing='keyboard_arrow_down' disabled={isLoading || storeCount === 0} >Take Action</Button>
      </div>
    </div>
  );
};

export default OnboardingActionCard;